module.exports = __webpack_public_path__ + "static/media/medisonal.82dad7d0.jpg";